import { render, staticRenderFns } from "./UserBookAppointmentModal.vue?vue&type=template&id=136950e2&"
import script from "./UserBookAppointmentModal.vue?vue&type=script&lang=ts&"
export * from "./UserBookAppointmentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports